var exports = {
  "KQ": "accentText__LyGFu0",
  "ks": "doneText__oSZ2h2",
  "uV": "noteBox__GvXzoj",
  "iP": "smallParagraph__kznDLd",
  "bv": "boldText__8Me-mm",
  "aO": "blockParagraph__4jv3Lg",
  "r8": "mutedSmallParagraph__CwgJbG",
  "G7": "indentedList__f3giGL",
};

module.exports = exports;
